import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { computed, nextTick, onMounted, ref } from 'vue';
import { setCurrentPageTitle } from '@/core/helpers/breadcrumb';
import { useRouterCustom } from '@/core/hooks/use-router-custom';
import {
  ChenhLechVatTuBienBanResponse,
  IKhoResponseBase,
  IPhieuXuatKhoResponseBase,
  IUserResponse
} from '@/core/interfaces/ApiResponses';
import { useLoading } from '@/core/hooks/use-loading';
import { getErrorMsg, swalErrNotification, swalNotification } from '@/core/helpers/utils';
import { UserService } from '@/core/services/UserService';
import { useCreatingForm } from '@/core/hooks/use-creating-form';
import ButtonCustom from '@/components/shared/buttons/ButtonCustom.vue';
import DivCol from '@/layout/_shared/DivCol.vue';
import DivRow from '@/layout/_shared/DivRow.vue';
import LabelCustom from '@/components/shared/label-custom/LabelCustom.vue';
import PageRowLayout from '@/layout/_shared/PageRowLayout.vue';
import PhieuXuatKhoService from '@/core/services/Receipt.service';
import VatTuXuatKhoThuongTable
  from '@/views/crafted/pages/receipts/vat-tu-xuat-kho-thuong-table/VatTuXuatKhoThuongTable.vue';
import { useButtonCustom } from '@/core/hooks/use-button-custom';
import { ICreateOrUpdatePhieuXuatKhac } from '@/core/interfaces/Models';


export default /*#__PURE__*/_defineComponent({
  __name: 'FormEditingPhieuXuatThuong',
  setup(__props) {

const { goBack, id: idPhieuXuat, replace } = useRouterCustom('idPhieuXuatKho');

const { endLoading, startLoading } = useLoading();

const { ButtonsType, ButtonTypeColors } = useButtonCustom();

setCurrentPageTitle('Phiếu xuất kho');

const phieuXuatKhoDetail = ref<IPhieuXuatKhoResponseBase | null>(null);

const { formRef } = useCreatingForm();

const form = ref({
  id_nguoi_nhan: 0,
  ly_do: '',
  ngay: new Date(),
  so_bien_ban: '',
});

const fromDateValidation = (_, value, callback) => {
  if (!value) {
    callback(new Error('Bắt buộc phải nhập'));
  }

  callback();
}

const rules = ref({
  id_nguoi_nhan: [
    {
      type: 'number',
      message: "Phải chọn người nhận",
      trigger: 'change',
      min : 1,
    }
  ],
  ngay: [
    {
      validator: fromDateValidation,
      trigger: 'change',
    }
  ],
  so_bien_ban: [
    {
      required: true,
      message:'Phải nhập số biên bản',
      trigger: 'blur',
    },
  ],
});

const transformPayload = (): ICreateOrUpdatePhieuXuatKhac => ({
  id_phieu_xuat: idPhieuXuat.value,
  id_kho: phieuXuatKhoDetail.value?.id_kho || 0,
  id_nguoi_nhan: form.value.id_nguoi_nhan,
  ly_do: form.value.ly_do,
  ngay: form.value.ngay,
  so_bien_ban: form.value.so_bien_ban,
  vat_tu_items: phieuXuatKhoDetail.value?.vat_tu_xuat_kho || [],
});

const chenhLechVatTuArray = ref<ChenhLechVatTuBienBanResponse[]>([]);

const fetchPhieuXuatDetail = async () => {
  if (idPhieuXuat.value) {
    try {
      await startLoading();

      const { data: { data: responsePhieuXuat } } = await PhieuXuatKhoService.get(idPhieuXuat.value);

      phieuXuatKhoDetail.value = {
        hoan_thanh: responsePhieuXuat.hoan_thanh,
        id: responsePhieuXuat.id,
        id_bien_ban_giai_the: responsePhieuXuat.id_bien_ban_giai_the,
        id_bo_phan: responsePhieuXuat.id_bo_phan,
        id_don_vi: responsePhieuXuat.id_don_vi,
        id_kho: responsePhieuXuat.id_kho,
        id_nguoi_dung: responsePhieuXuat.id_nguoi_nhan,
        id_nguoi_nhan: responsePhieuXuat.id_nguoi_nhan,
        is_approved: responsePhieuXuat.is_approved,
        kho: responsePhieuXuat.kho as IKhoResponseBase,
        ly_do: responsePhieuXuat.ly_do,
        loai_phieu: 0,
        nam: responsePhieuXuat.nam,
        ngay: responsePhieuXuat.ngay,
        ngay_hoan_thanh: responsePhieuXuat.ngay_hoan_thanh,
        so_bien_ban: responsePhieuXuat.so_bien_ban,
        so_phieu: responsePhieuXuat.so_phieu,
        vat_tu_xuat_kho: responsePhieuXuat.vat_tu_xuat_kho,
        nguoi_nhan: responsePhieuXuat.nguoi_nhan as IUserResponse,
        total_export_amount: +responsePhieuXuat.total_export_amount,
        created_at: responsePhieuXuat.created_at,
        updated_at: responsePhieuXuat.updated_at,
        count_not_in_dmd: +responsePhieuXuat.count_not_in_dmd,
      };

      if (!phieuXuatKhoDetail.value) return;

      await nextTick();

      if (!isPhieuXuatTdm.value) {
        const {
          data: {
            data,
          },
        } = await PhieuXuatKhoService.vaildateVatTuXuatKho({
          id: phieuXuatKhoDetail.value.id_bien_ban_giai_the,
          exclude_id_phieu_xuat_items: [idPhieuXuat.value],
        });

        chenhLechVatTuArray.value = data;
      }

      form.value.id_nguoi_nhan = phieuXuatKhoDetail.value.id_nguoi_nhan;

      form.value.ly_do = phieuXuatKhoDetail.value.ly_do;

      form.value.ngay = phieuXuatKhoDetail.value.ngay ? new Date(phieuXuatKhoDetail.value.ngay) : new Date();

      form.value.so_bien_ban = phieuXuatKhoDetail.value.so_bien_ban;

      await endLoading();
    } catch (e) {
      await endLoading();

      await swalErrNotification(getErrorMsg(e), 'Lỗi khi lấy thông tin phiếu xuất');
    }
  }
}

const isPhieuXuatTdm = computed<boolean>(() => {
  if (!phieuXuatKhoDetail.value) return false;

  return phieuXuatKhoDetail.value.count_not_in_dmd > 0;
});

const nguoiDungItems = ref<IUserResponse[]>([]);

const fetchNguoiDung = async () => {
  const { data: { data: { data } } } = await UserService.list();

  nguoiDungItems.value = data;
}

onMounted(async () => {
  await fetchPhieuXuatDetail();

  await fetchNguoiDung();
});

const removeVatTu = (id: number) => {
  if (!phieuXuatKhoDetail.value) return;

  const index = phieuXuatKhoDetail.value.vat_tu_xuat_kho.findIndex(({ id: idVatTu }) => idVatTu === id);

  if (index >= 0 && phieuXuatKhoDetail.value) {
    phieuXuatKhoDetail.value.vat_tu_xuat_kho.splice(index, 1);
  }
}

const errors = ref<{
  id: number;
  msg: string;
}[]>([])

const onSubmit = () => {
  errors.value = [];

  if (!formRef.value) return;

  if (phieuXuatKhoDetail.value?.vat_tu_xuat_kho.length === 0) {
    swalErrNotification(null, 'Phải chọn vật tư cho phiếu xuất');

    return;
  }

  formRef.value.validate(async (isValid: boolean) => {
    if (isValid) {
      try {
        const { data: { data } } = await PhieuXuatKhoService.createOrUpdatePhieuXuatKhac(transformPayload());

        await replace(`/quan-ly/bien-ban-giai-the/${phieuXuatKhoDetail.value?.id_bien_ban_giai_the || 0}/phieu-xuat/chi-tiet/${data.id}`);
      } catch (e: any) {
        await endLoading();

        await swalNotification(
          getErrorMsg(e),
          'error',
        );

        if (e.response.data.data?.data?.length) {
          errors.value = e.response.data.data.data;
        }
      }

      return;
    }

    return false;
  })
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(PageRowLayout, null, {
    "page-row-header": _withCtx(() => [
      _createTextVNode("Chỉnh sửa")
    ]),
    "page-row-action-button": _withCtx(() => [
      _createVNode(ButtonCustom, {
        "button-type": _unref(ButtonsType).BACK,
        onClick: _unref(goBack)
      }, null, 8, ["button-type", "onClick"])
    ]),
    "page-row-content": _withCtx(() => [
      _createVNode(_component_el_form, {
        model: form.value,
        rules: rules.value,
        ref_key: "formRef",
        ref: formRef,
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onSubmit()), ["prevent"]))
      }, {
        default: _withCtx(() => [
          _createVNode(DivRow, null, {
            default: _withCtx(() => [
              _createVNode(DivCol, { cols: 2 }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Số phiếu:")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_RouterLink, {
                    class: "nav nav-underline",
                    target: "_blank",
                    to: `/quan-ly/bien-ban-giai-the/${phieuXuatKhoDetail.value?.id_bien_ban_giai_the}/phieu-xuat/chi-tiet/${_unref(idPhieuXuat)}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(phieuXuatKhoDetail.value?.so_phieu), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, { cols: 2 }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Xuất tại kho:")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, { "is-bolder": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(phieuXuatKhoDetail.value?.kho.ten_kho), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Ngày:")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "ngay",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: form.value.ngay,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.ngay) = $event)),
                        format: "DD/MM/YYYY",
                        name: "ngay",
                        type: "date"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode("Người nhận hàng:")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "id_nguoi_nhan",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: form.value.id_nguoi_nhan,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.id_nguoi_nhan) = $event)),
                        name: "id_nguoi_nhan",
                        onChange: () => {}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Chưa chọn",
                            value: -1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nguoiDungItems.value, (user) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: user.id,
                              label: user.ho_va_ten,
                              value: user.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, {
                    "is-text-muted": true,
                    "is-required": true
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Số biên bản:")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 3 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "so_bien_ban",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.so_bien_ban,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.so_bien_ban) = $event)),
                        name: "so_bien_ban"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, { class: "mt-5" }, {
            default: _withCtx(() => [
              _createVNode(DivCol, {
                cols: 2,
                class: "d-flex"
              }, {
                default: _withCtx(() => [
                  _createVNode(LabelCustom, { "is-text-muted": true }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Lý do: ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivCol, { cols: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    prop: "ly_do",
                    class: "mb-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.ly_do,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.ly_do) = $event)),
                        name: "ly_do",
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(DivRow, null, {
            default: _withCtx(() => [
              _createVNode(DivCol, { cols: 11 }),
              _createVNode(DivCol, null, {
                default: _withCtx(() => [
                  _createVNode(ButtonCustom, {
                    "button-type": _unref(ButtonsType).SAVE,
                    "color-type": _unref(ButtonTypeColors).SUCCESS,
                    onClick: onSubmit
                  }, null, 8, ["button-type", "color-type"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (phieuXuatKhoDetail.value)
            ? (_openBlock(), _createBlock(DivRow, {
                key: 0,
                class: "mt-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, { cols: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(VatTuXuatKhoThuongTable, {
                        "chenh-lech-vat-tu-arr": chenhLechVatTuArray.value,
                        errors: errors.value,
                        "id-kho": phieuXuatKhoDetail.value.id_kho,
                        items: phieuXuatKhoDetail.value.vat_tu_xuat_kho,
                        "is-ngoai-dinh-muc": !isPhieuXuatTdm.value,
                        onRemove: removeVatTu
                      }, null, 8, ["chenh-lech-vat-tu-arr", "errors", "id-kho", "items", "is-ngoai-dinh-muc"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }))
}
}

})